var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "blue-box" }, [
    _c("div", { staticClass: "blue-box__inner" }, [
      _c(
        "div",
        { staticClass: "blue-box__body" },
        [
          !!_vm.title
            ? _c("h2", {
                staticClass: "blue-box__title heading-secondary",
                domProps: { innerHTML: _vm._s(_vm.$t(_vm.title)) },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.texts, function (text, index) {
            return _c("p", {
              key: index,
              staticClass: "blue-box__desc paragraph-primary",
              domProps: { innerHTML: _vm._s(_vm.$t(text)) },
            })
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }